import Vue from 'vue'
import Router from 'vue-router'
import ucarStorage from './utils/storage'
import Env from './utils/jsBridge/env'
import index from './pages/old/index'
import introduction from './pages/old/introduction'
import companyIntroduction from './pages/old/company-introduction'
import teamIntroduction from './pages/old/team-introduction'
import showcase from './pages/old/showcase'
import protocol from './pages/old/protocol'
import login from './pages/old/login'
import enrollResult from './pages/old/enroll-result'
import bookInterview from './pages/old/book-interview'
import personInfo from './pages/old/person-info'
import carInfo from './pages/old/car-info'
import teamInfo from './pages/old/team-info'
import teamActivating from './pages/old/team-activating'
import teamResult from './pages/old/team-result'
import psd from './pages/old/psd'
import driverInfo from './pages/new/driver-info.vue'
import vehicleInfo from './pages/new/vehicle-info.vue'
import videoInfo from './pages/new/video-info.vue'
import progressInfo from './pages/new/progress-info.vue'
import lessonList from './pages/train/lesson-list.vue'
import lessonDetail from './pages/train/lesson-detail.vue'
import examDetail from './pages/train/exam-detail.vue'
import examResult from './pages/train/exam-result.vue'
import bindFail from './pages/new/bind-fail.vue'
import authorizeProtocol from './pages/new/authorize-protocol.vue'
import driverInfoNew from './pages/newRecruit/new-driver-info.vue'
import credentialsUpload from './pages/recruitForApp/credentials-upload.vue'
import appDriverInfo from './pages/recruitForApp/app-driver-info.vue'
import progressInfoNew from './pages/newRecruit/new-progress-info.vue'
import newVehicleInfo from './pages/newRecruit/new-vehicle-info.vue'
import driverInfoSimpleSubmit from './pages/newRecruit/simple-driver-info.vue'
import zcsxEntry from './pages/recruitForApp/zcsxEntry.vue'
import appVehicleInfo from './pages/recruitForApp/app-vehicle-info.vue'

import {
  vuexMixin,
  trainMixin,
  titleMixin,
  loginStatusMixin,
  modifyMixin,
  resetLoginStatusMixin,
  hmMixin,
} from './mixins'
import { loginStatus } from './utils/constants'
// 加载混合器
const extendMixin = (instance, ...mixins) => {
  instance.mixins = instance.mixins ? instance.mixins.concat(mixins) : mixins
  return instance
}
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: extendMixin(
        index,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        resetLoginStatusMixin,
        hmMixin
      ),
    },
    {
      path: '/introduction/:type',
      name: 'introduction',
      component: extendMixin(
        introduction,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        resetLoginStatusMixin,
        hmMixin
      ),
    },
    {
      path: '/company-introduction',
      name: 'company-introduction',
      component: extendMixin(
        companyIntroduction,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        resetLoginStatusMixin
      ),
    },
    {
      path: '/team-introduction',
      name: 'team-introduction',
      component: extendMixin(
        teamIntroduction,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        resetLoginStatusMixin
      ),
    },
    {
      path: '/showcase/:type',
      name: 'showcase',
      component: extendMixin(showcase, titleMixin, resetLoginStatusMixin),
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: extendMixin(protocol, titleMixin, resetLoginStatusMixin),
    },
    {
      path: '/login',
      name: 'login',
      component: extendMixin(
        login,
        vuexMixin,
        loginStatusMixin,
        resetLoginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/person-info',
      name: 'person-info',
      component: extendMixin(
        personInfo,
        modifyMixin,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/car-info',
      name: 'car-info',
      component: extendMixin(
        carInfo,
        modifyMixin,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/team-info',
      name: 'team-info',
      component: extendMixin(teamInfo, vuexMixin, loginStatusMixin, titleMixin),
    },
    {
      path: '/team-activating',
      name: 'team-activating',
      component: extendMixin(
        teamActivating,
        vuexMixin,
        loginStatusMixin,
        titleMixin
      ),
    },
    {
      path: '/team-result',
      name: 'team-result',
      component: extendMixin(
        teamResult,
        vuexMixin,
        loginStatusMixin,
        titleMixin
      ),
    },
    {
      path: '/enroll-result',
      name: 'enroll-result',
      component: extendMixin(
        enrollResult,
        vuexMixin,
        loginStatusMixin,
        titleMixin
      ),
    },
    {
      path: '/book-interview',
      name: 'book-interview',
      component: extendMixin(
        bookInterview,
        vuexMixin,
        loginStatusMixin,
        titleMixin
      ),
    },
    {
      path: '/psd',
      name: 'psd',
      component: extendMixin(psd, resetLoginStatusMixin),
    },
    {
      path: '/driver-info',
      name: 'driver-info',
      component: extendMixin(
        driverInfo,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/vehicle-info',
      name: 'vehicle-info',
      component: extendMixin(
        vehicleInfo,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/video-info',
      name: 'video-info',
      component: extendMixin(
        videoInfo,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/progress-info',
      name: 'progress-info',
      component: extendMixin(
        progressInfo,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin,
        resetLoginStatusMixin
      ),
    },
    {
      path: '/lesson-list',
      name: 'lesson-list',
      component: extendMixin(
        lessonList,
        vuexMixin,
        trainMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/lesson-detail/:id',
      name: 'lesson-detail',
      component: extendMixin(
        lessonDetail,
        vuexMixin,
        trainMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/exam-detail',
      name: 'exam-detail',
      component: extendMixin(
        examDetail,
        vuexMixin,
        trainMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/exam-result',
      name: 'exam-result',
      component: extendMixin(
        examResult,
        vuexMixin,
        trainMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/bind-fail',
      name: 'bind-fail',
      component: extendMixin(
        bindFail,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/authorize-protocol',
      name: 'authorize-protocol',
      component: extendMixin(
        authorizeProtocol,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/new-vehicle-info',
      name: 'new-vehicle-info',
      component: extendMixin(
        newVehicleInfo,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/new-driver-info',
      name: 'new-driver-info',
      component: extendMixin(
        driverInfoNew,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/credentials-upload',
      name: 'credentials-upload',
      component: extendMixin(
        credentialsUpload,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/simple-driver-info',
      name: 'simple-driver-info',
      component: extendMixin(
        driverInfoSimpleSubmit,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/app-driver-info',
      name: 'app-driver-info',
      component: extendMixin(
        appDriverInfo,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin
      ),
    },
    {
      path: '/new-progress-info',
      name: 'new-progress-info',
      component: extendMixin(
        progressInfoNew,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin,
        resetLoginStatusMixin
      ),
    },
    {
      path: '/zcsxEntry',
      name: 'zcsxEntry',
      component: extendMixin(
        zcsxEntry,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin,
        resetLoginStatusMixin
      ),
    },
    {
      path: '/app-vehicle-info',
      name: 'app-vehicle-info',
      component: extendMixin(
        appVehicleInfo,
        vuexMixin,
        loginStatusMixin,
        titleMixin,
        hmMixin,
        resetLoginStatusMixin
      ),
    },
  ],
})

router.beforeEach((to, from, next) => {
  console.log(to,'totottotoot');
  // if (true) {
  //   next()
  //   return
  // }
  const routerReg = new RegExp('index|login|introduction|psd|showcase|protocol', 'i')
  const fillInfoReg = new RegExp('person-info|car-info|team-info|driver-info|vehicle-info|video-info|progress-info|bind-fail|authorize-protocol|new-driver-info|simple-driver-info|new-vehicle-info', 'i')
  const reviewInfoReg = new RegExp('enroll-result|approval-status|progress-info|lesson-list|lesson-detail|exam-detail|exam-result|bind-fail|new-driver-info|new-progress-info|simple-driver-info', 'i')
  const teamReviewInfoReg = new RegExp('team-result|team-activating', 'i')
  const modifyInfoReg = new RegExp('person-info|car-info|book-interview', 'i')
  const appInfoReg = new RegExp('zcsxEntry|app-vehicle-info|credentials-upload|app-driver-info', 'i')
  // 当前登录状态 1.新用户填写信息状态 2.查看当前报名进度状态 3.退回修改状态 4.车队报名审核审核信息状态 5.车队已激活状态
  const currentLoginStatus = ucarStorage.getSession('ucar-login-status')
  // 当前登录类型 1.新版本司机 2.老版本司机
  const currentLoginType = ucarStorage.getSession('login-type')
  // 当前招募id 已报名的新老版本用户都有
  const currentRecruitId = ucarStorage.getSession('recruit-id')
  // 当前服务城市
  const currentCity = ucarStorage.getSession('current-city')
  const serviceCitys = ucarStorage.getSession('service-cities')

  try {
    // 当进入首页或海报页时允许没有服务城市
    if (!serviceCitys && !/index|psd/.test(to.name)) {
      if (appInfoReg.test(to.name) && Env.getAppInfo().isUCar && to.query.enlistId) {
        next()
        return
      } else {
        next('/')
      }
    }
    if (routerReg.test(to.name)) {
      // 由于微博的分享限制，url中不可带有#，所以在目前不更改nginx配置的情况下只能这样处理
      if (location.search) {
        let queryStr = ''
        if (to.query && Object.keys(to.query).length > 0) {
          for (let key in to.query) {
            queryStr += `&${key}=${to.query[key]}`
          }
        }
        if (document.referrer && !/10101111\.com/.test(document.referrer)) {
          Vue.prototype.$store.commit('setVuexFrom', 'search')
          ucarStorage.setSession('document-referrer', document.referrer)
        }
        location.assign(
          `${location.protocol}//${location.host}/#/${location.search}${queryStr}`
        )
        return
      }
      if (to.name === 'login') {
        // 当用户处于车队招募查看招募进度状态时，需跳过登录页直接进入报名进度页
        if (currentLoginStatus === loginStatus.teamReviewInfo) {
          next(`/team-result?id=${currentRecruitId}`)
          return
        }
        // 当司机处于填写退回修改状态或查看报名进度状态时，需跳过登录页直接进入报名进度页
        if (
          currentLoginStatus === loginStatus.reviewInfo ||
          currentLoginStatus === loginStatus.modifyInfo
        ) {
          next(
            !currentLoginType || currentLoginType === 1
              ? `/progress-info?id=${currentRecruitId}`
              : `/enroll-result?id=${currentRecruitId}`
          )
          return
        }
      }
      // 未通过审核的司机需要特殊处理一下，首页直接跳转到报名流程详情页，并设置登录状态为reviewInfo以及设置regType为相应值
      if (to.name === 'index' && to.query.regType && to.query.driverId) {
        ucarStorage.setSession('ucar-login-status', loginStatus.reviewInfo)
        ucarStorage.setSession('reg-type', to.query.regType)
        next({
          name: 'enroll-result',
          query: {
            regType: to.query.regType,
            id: to.query.driverId,
          },
        })
        // 当没有服务城市时，如果进入的是加入方式介绍页或车辆展示页，则直接跳转到首页
      } else if (
        !currentCity &&
        (/introduction|showcase/.test(to.name) ||
          (to.name === 'login' && to.query.regType))
      ) {
        next('/')
      } else {
        next()
      }
    } else {
      // 当缓存中的登录状态处于相应的状态时，才可进入相应的链接（审核页面比较特殊，reviewInfo、modifyInfo状态均可进入）
      // 新招募流程：查看招募进度页和车辆审核失败信息展示页比较特殊，填充信息状态，与审核状态均可进入这两个页面
      if (
        (fillInfoReg.test(to.name) &&
          currentLoginStatus === loginStatus.fillInfo) ||
        (reviewInfoReg.test(to.name) &&
          (currentLoginStatus === loginStatus.reviewInfo ||
            currentLoginStatus === loginStatus.modifyInfo)) ||
        (teamReviewInfoReg.test(to.name) &&
          (currentLoginStatus === loginStatus.teamReviewInfo ||
            currentLoginStatus === loginStatus.teamActivated)) ||
        (modifyInfoReg.test(to.name) &&
          currentLoginStatus === loginStatus.modifyInfo)
      ) {
        next()
      } else{
        next('/')
      }
    }
  } catch (error) {
    console.warn(error)
  }
})
export default router
